import React from "react";
import { CheckCircle2Icon } from "lucide-react"; // Or use your own icon

const OrderSuccessModal = ({ orderId, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
      <div className="bg-gray-900 border border-purple-700 rounded-3xl shadow-2xl p-8 w-full max-w-md text-center relative animate-fadeIn">
        
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-green-500 to-green-700 shadow-lg">
            <CheckCircle2Icon className="text-white w-12 h-12" />
          </div>
        </div>

        <h2 className="text-2xl sm:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600 mb-3">
          Order Placed Successfully!
        </h2>

        {/* <p className="text-sm text-gray-300 mb-2">
          Your Order ID:{" "}
          <span className="font-bold text-cyan-400 break-all">{orderId}</span>
        </p> */}

        <p className="text-sm text-gray-400 mb-6">
          Thank you for shopping with us!
        </p>

        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 to-cyan-500 text-white font-semibold shadow-lg hover:scale-105 transition-transform"
        >
          View My Orders
        </button>

        {/* Decorative Glow */}
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-b-3xl"></div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;
